import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReusableComponentsVehicleModeEnum } from '../../../generated/graphql';
import {
  SimpleButtonDropdownMenu,
  SimpleDropdownMenuItem,
} from '../../common/Dropdowns';

const testIds: Readonly<Record<string, string>> = {
  addBusStop: 'AddStopDropdownOption::addBusStop',
  addTramStop: 'AddStopDropdownOption::addTramStop',
  addDepotStop: 'AddStopDropdownOption::addDepotStop',
};

type MapFooterAddStopDropdownProps = {
  readonly onAddStops: (vehicleMode: ReusableComponentsVehicleModeEnum) => void;
  readonly onAddDepotStop: () => void;
  readonly testId: string;
  readonly disabled?: boolean;
  readonly inverted?: boolean;
};

export const MapFooterAddStopDropdown: FC<MapFooterAddStopDropdownProps> = ({
  onAddStops,
  onAddDepotStop,
  testId,
  disabled,
  inverted,
}) => {
  const { t } = useTranslation();
  return (
    <SimpleButtonDropdownMenu
      buttonText={t(($) => $.map.addStop)}
      disabled={disabled}
      inverted={inverted}
      testId={testId}
      disabledTooltip={t(($) => $.dataModelRefactor.disabled)}
    >
      <SimpleDropdownMenuItem
        testId={testIds.addBusStop}
        data-vehicle-mode={ReusableComponentsVehicleModeEnum.Bus}
        onClick={() => onAddStops(ReusableComponentsVehicleModeEnum.Bus)}
      >
        {t(($) => $.map.addBusStop)}
      </SimpleDropdownMenuItem>
      <SimpleDropdownMenuItem
        testId={testIds.addTramStop}
        data-vehicle-mode={ReusableComponentsVehicleModeEnum.Tram}
        onClick={() => onAddStops(ReusableComponentsVehicleModeEnum.Tram)}
      >
        {t(($) => $.map.addTramStop)}
      </SimpleDropdownMenuItem>
      <SimpleDropdownMenuItem
        testId={testIds.addDepotStop}
        onClick={onAddDepotStop}
      >
        {t(($) => $.map.addDepotStop)}
      </SimpleDropdownMenuItem>
    </SimpleButtonDropdownMenu>
  );
};
